var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4591_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8663 2.954L14.1532 1.18475C13.9429 0.968724 13.6915 0.79688 13.4138 0.679296C13.1361 0.561712 12.8378 0.500755 12.5363 0.5H9C8.13585 0.501091 7.29849 0.800068 6.62906 1.34654C5.95964 1.89301 5.49907 2.65356 5.325 3.5H5.25C4.2558 3.50119 3.30267 3.89666 2.59966 4.59966C1.89666 5.30267 1.50119 6.2558 1.5 7.25V14.75C1.50119 15.7442 1.89666 16.6973 2.59966 17.4003C3.30267 18.1033 4.2558 18.4988 5.25 18.5H9.75C10.7442 18.4988 11.6973 18.1033 12.4003 17.4003C13.1033 16.6973 13.4988 15.7442 13.5 14.75V14.675C14.3464 14.5009 15.107 14.0404 15.6535 13.3709C16.1999 12.7015 16.4989 11.8642 16.5 11V4.52C16.5011 3.93531 16.2737 3.37334 15.8663 2.954ZM9.75 17H5.25C4.65326 17 4.08097 16.7629 3.65901 16.341C3.23705 15.919 3 15.3467 3 14.75V7.25C3 6.65326 3.23705 6.08097 3.65901 5.65901C4.08097 5.23705 4.65326 5 5.25 5V11C5.25119 11.9942 5.64666 12.9473 6.34966 13.6503C7.05267 14.3533 8.0058 14.7488 9 14.75H12C12 15.3467 11.7629 15.919 11.341 16.341C10.919 16.7629 10.3467 17 9.75 17ZM12.75 13.25H9C8.40326 13.25 7.83097 13.0129 7.40901 12.591C6.98705 12.169 6.75 11.5967 6.75 11V4.25C6.75 3.65326 6.98705 3.08097 7.40901 2.65901C7.83097 2.23705 8.40326 2 9 2H12V3.5C12 3.89782 12.158 4.27936 12.4393 4.56066C12.7206 4.84196 13.1022 5 13.5 5H15V11C15 11.5967 14.7629 12.169 14.341 12.591C13.919 13.0129 13.3467 13.25 12.75 13.25Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4591_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.34439b338c92fa7a52d17f5a66fbcbe5.svg";
export { ForwardRef as ReactComponent };